import { render, staticRenderFns } from "./Hotsite.vue?vue&type=template&id=7912398a&scoped=true"
import script from "./Hotsite.vue?vue&type=script&lang=js"
export * from "./Hotsite.vue?vue&type=script&lang=js"
import style0 from "./Hotsite.vue?vue&type=style&index=0&id=7912398a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912398a",
  null
  
)

export default component.exports